import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class Notification extends Component
{
    constructor(props) {
        super(props);

        this.state = {

        };
    }
    
    render()
    {
        const { notification } = this.props;
        console.log("notification", notification);
        
        return (
            <div>
                {(
                    notification == 'booking_failed' &&
                    <div className="alert alert-danger alert-dismissible fade show p-4">
                        <h5 className="font-weight-bold body-font">Oops, something went wrong!</h5>
                        <div>We were unable to process your reservation. You can try again to see if the problem goes away, or <a target="_blank" href="/contact-us">contact us</a> to complete your booking.</div>
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                ) || (
                    notification &&
                    <div className="alert alert-danger alert-dismissible fade show p-4">
                        <h5 className="font-weight-bold body-font">{ notification }</h5>
                        <div>We were unable to process a payment using the information provided. Please re-enter your payment information and try again to complete your booking.</div>
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                ) }       
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/Notification.js